import React, { useEffect, useState } from "react";
import { CustomLabel, Modal, LinkProductsContainer } from "../../../styled/setting";
import Search from "../../common/search";
import { IoClose } from "react-icons/io5";

const LinkProducts = ({ toggleModal, menuGroup, setMenuGroup, products = null }) => {
  const [data, setData] = useState([]);
  const [searched, setSearched] = useState("");
  const [checked, setChecked] = useState([]);

  useEffect(() => {
    setData(products ? [...products] : []);
    setChecked((menuGroup?.products || []).map(({ id }) => id));
  }, [products]);

  const toggleCheck = (id) => {
    if (checked.includes(id)) {
      setChecked((data) => [...data].filter((checked) => id !== checked));
    } else {
      setChecked((data) => [...data, id]);
    }
  };

  const onSubmit = () => {
    setMenuGroup((group) => ({
      ...group,
      products: [...products].filter((item) => checked.includes(item.id)),
    }));
    toggleModal();
  };

  const searchProduct = (flag = false) => {
    setData(flag ? products : products.filter((ele) => ele.name.includes(searched)));
  };

  return (
    <Modal onClick={(e) => e.currentTarget === e.target && toggleModal()}>
      <div className="modal">
        <LinkProductsContainer>
          <strong className="label">메뉴그룹정보</strong>
          <div className="option">
            <div>
              <span className="tit">메뉴그룹명</span>
              <span className="cont">{menuGroup.name}</span>
            </div>
            <div>
              <span className="tit"></span>
              <span className="cont"></span>
            </div>
          </div>
          <strong className="label">상품</strong>
          <div className="products">
            <Search
              setSearched={setSearched}
              searched={searched}
              searchEvent={searchProduct}
              placeholder="상품명을 입력해주세요"
            />
            <ul>
              {data && data.length > 0 ? (
                data.map((item) => (
                  <li>
                    <CustomLabel>
                      <input
                        type="checkbox"
                        checked={checked.includes(item.id)}
                        onChange={() => toggleCheck(item.id)}
                      />
                      <div className="checkmark"></div>
                    </CustomLabel>
                    <img
                      src={
                        item.media && item.media.length > 0
                          ? imgHandler(item.media)
                          : "/img/icon_function_4.png"
                      }
                      alt={item.name}
                      onError={(e) => (e.target.src = "/img/icon_function_4.png")}
                    />
                    <div className="productInfo">
                      <span>상품코드 {item.cloudProduct.id}</span>
                      <span className="name">{item.name}</span>
                      <span>{formatNumber(item.price)}원</span>
                    </div>
                  </li>
                ))
              ) : (
                <li className="not">메뉴가 존재하지 않습니다.</li>
              )}
            </ul>
          </div>
          <div>
            <button className="submit" onClick={onSubmit}>
              저장
            </button>
          </div>
          <button className="closeModal" onClick={() => toggleModal()}>
            <IoClose />
          </button>
        </LinkProductsContainer>
      </div>
    </Modal>
  );
};

export default LinkProducts;
